import React, { CSSProperties, DetailedHTMLProps, FC, HTMLAttributes } from "react";
import { ClassNames } from "../../modules/utils";

export interface IBoxProps {
  title: any;
  description?: any;
  style?: CSSProperties;
  className?: string;
  headClassName?: string;
  titleRight?: any;
  onTitleClick?: () => void;
  contentProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
}

export const Box: FC<IBoxProps> = (props) => {
  return (
    <div style={props.style} className={ClassNames({ Box: true, [props.className as string]: !!props.className })}>
      <div className={"head" + (props.headClassName ? " " + props.headClassName : "")}>
        <div className="title" onClick={props.onTitleClick ? props.onTitleClick : () => {}}>
          {props.title}
        </div>
        {props.titleRight}
      </div>
      {props.description ? <div className="description">{props.description}</div> : null}
      <div className="content" {...props.contentProps}>
        {props.children}
      </div>
    </div>
  );
};
